import { ReactNode, createContext } from "react";
import useTipoDespesasVendedor, { CreateTipoDespesasVendedorType, TipoDespesasVendedorType, UpdateTipoDespesasVendedorType} from "./hooks/useTipoDespesasVendedor";

interface TipoDespesasVendedorContextProviderProps {
    children: ReactNode;
}

export interface TipoDespesasVendedorContextData {
    getAllTipoDespesasVendedorPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<TipoDespesasVendedorType[] | null>;
    setTipoDespesasVendedor: any;
    tipoDespesasVendedor: TipoDespesasVendedorType;
    setListTipoDespesasVendedor: any;
    listTipoDespesasVendedor: TipoDespesasVendedorType[];
    setInitialListTipoDespesasVendedor: any;
    initialListTipoDespesasVendedor: TipoDespesasVendedorType[];
    setTipoDespesasVendedorPageCount: any;
    tipoDespesasVendedorPageCount: number;
    createTipoDespesasVendedor: (createTipoDespesasVendedorType: CreateTipoDespesasVendedorType) => Promise<CreateTipoDespesasVendedorType | null>;
    updateTipoDespesasVendedor: (updateTipoDespesasVendedorType: UpdateTipoDespesasVendedorType) => Promise<UpdateTipoDespesasVendedorType | null>;
    deleteTipoDespesasVendedor: (id: number) => Promise<TipoDespesasVendedorType | null>;
    handleGetTipoDespesasVendedorByEmpresaId: (empresaId: number) => Promise<TipoDespesasVendedorType[] | null>;
    listTipoDespesasVendedorByEmpresa: TipoDespesasVendedorType[];
    setListTipoDespesasVendedorByEmpresa: any;
}

const initialState: TipoDespesasVendedorContextData = {
    getAllTipoDespesasVendedorPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setTipoDespesasVendedor: () => { },
    tipoDespesasVendedor: {
        id: 0,
        name: "",
        icon: "",
    },
    setListTipoDespesasVendedor: () => { },
    listTipoDespesasVendedor: [],
    setInitialListTipoDespesasVendedor: () => { },
    initialListTipoDespesasVendedor: [],
    setTipoDespesasVendedorPageCount: () => { },
    tipoDespesasVendedorPageCount: 0,
    createTipoDespesasVendedor: async (createTipoDespesasVendedorType: CreateTipoDespesasVendedorType) => {
        return Promise.resolve(null);
    },
    updateTipoDespesasVendedor: async (updateTipoDespesasVendedorType: UpdateTipoDespesasVendedorType) => {
        return Promise.resolve(null);
    },
    deleteTipoDespesasVendedor: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetTipoDespesasVendedorByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listTipoDespesasVendedorByEmpresa: [],
    setListTipoDespesasVendedorByEmpresa: () => { },
};

export const TipoDespesasVendedorContext =
    createContext<TipoDespesasVendedorContextData>(initialState);

export default function TipoDespesasVendedorContextProvider({
    children,
}: TipoDespesasVendedorContextProviderProps) {
    const {
        getAllTipoDespesasVendedorPaged,
        createTipoDespesasVendedor,
        updateTipoDespesasVendedor,
        deleteTipoDespesasVendedor,
        tipoDespesasVendedor,
        setTipoDespesasVendedor,
        setListTipoDespesasVendedor,
        listTipoDespesasVendedor,
        initialListTipoDespesasVendedor,
        setInitialListTipoDespesasVendedor,
        setTipoDespesasVendedorPageCount,
        tipoDespesasVendedorPageCount,
        handleGetTipoDespesasVendedorByEmpresaId,
        listTipoDespesasVendedorByEmpresa,
        setListTipoDespesasVendedorByEmpresa,
    } = useTipoDespesasVendedor();

    return (
        <TipoDespesasVendedorContext.Provider
            value={{
                getAllTipoDespesasVendedorPaged,
                createTipoDespesasVendedor,
                updateTipoDespesasVendedor,
                deleteTipoDespesasVendedor,
                tipoDespesasVendedor,
                setTipoDespesasVendedor,
                setListTipoDespesasVendedor,
                listTipoDespesasVendedor,
                initialListTipoDespesasVendedor,
                setInitialListTipoDespesasVendedor,
                setTipoDespesasVendedorPageCount,
                tipoDespesasVendedorPageCount,
                handleGetTipoDespesasVendedorByEmpresaId,
                listTipoDespesasVendedorByEmpresa,
                setListTipoDespesasVendedorByEmpresa,
            }}
        >
            {children}
        </TipoDespesasVendedorContext.Provider>
    );
}